var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as PIXI from "pixi.js";
import { Viewport } from "pixi-viewport";
import Ticker from "./Ticker.js";
import { a as assignGlobalSingleton } from "../global-33d5eebf.js";
class GameCoordinator {
  // instance: GameInstance;
  constructor() {
    __publicField(this, "scene");
    __publicField(this, "scenes", {});
    __publicField(this, "currentScene");
    __publicField(this, "pixiApp");
    __publicField(this, "pixiViewport");
    __publicField(this, "ticker");
    __publicField(this, "fillScreen", true);
    __publicField(this, "minWidth", 1080);
    __publicField(this, "minHeight", 1080);
    __publicField(this, "baseZoom");
    // Resize handler
    __publicField(this, "onResize", () => {
      if (this.fillScreen) {
        let windowWidth = Math.min(window.innerWidth, window.outerWidth);
        const canvas = this.pixiApp.renderer.view;
        canvas.style.width = `${window.innerWidth}px`;
        canvas.style.height = `${window.innerHeight}px`;
        canvas.style.left = "0px";
        canvas.style.top = "0px";
        this.pixiApp.renderer.resize(window.innerWidth, window.innerHeight);
        this.pixiViewport.resize(
          window.innerWidth,
          window.innerHeight,
          this.pixiViewport.worldWidth,
          this.pixiViewport.worldHeight
        );
        let scale = window.innerWidth / 1920;
        if (windowWidth < this.minWidth) {
          scale = this.minWidth / windowWidth * scale;
        }
        this.pixiViewport.setZoom(scale, true);
        this.baseZoom = scale;
      } else {
        let width = window.innerWidth;
        let height = window.innerWidth * 9 / 16;
        if (height > window.innerHeight) {
          height = window.innerHeight;
          width = window.innerHeight * 16 / 9;
        }
        const scale = Math.min(width / 1920, height / 1080);
        const scaledWidth = 1920 * scale;
        const scaledHeight = 1080 * scale;
        const canvas = this.pixiApp.renderer.view;
        canvas.style.width = `${scaledWidth}px`;
        canvas.style.height = `${scaledHeight}px`;
        canvas.style.left = `${(window.innerWidth - scaledWidth) / 2}px`;
        canvas.style.top = `${(window.innerHeight - scaledHeight) / 2}px`;
        this.pixiApp.renderer.resize(width, height);
        this.pixiViewport.resize(width, height, this.pixiViewport.worldWidth, this.pixiViewport.worldHeight);
        this.pixiViewport.setZoom(scale, true);
        this.baseZoom = scale;
      }
    });
    console.log("GAMECOORDINATOR CONSTRUCTED");
    this.setupPixi();
  }
  setupPixi() {
    if (this.pixiApp) {
      document.querySelectorAll(".pixi-canvas").forEach((el) => el.remove());
    }
    this.pixiApp = new PIXI.Application();
    const canvas = this.pixiApp.renderer.view;
    canvas.className = "pixi-canvas";
    canvas.style.position = "absolute";
    canvas.style.display = "block";
    canvas.style.zIndex = "-10";
    this.pixiApp.renderer.background.color = 0;
    this.pixiApp.renderer.resize(window.innerWidth, window.innerWidth * 9 / 16);
    this.pixiApp.ticker.stop();
    const viewport = new Viewport({
      screenWidth: window.innerWidth,
      screenHeight: window.innerWidth * 9 / 16,
      worldWidth: 1e6,
      worldHeight: 1e6,
      events: this.pixiApp.renderer.events
      // the interaction module is important for wheel to work properly when renderer.view is placed or scaled
    });
    const baseZoom = window.innerWidth / 1920;
    viewport.setZoom(baseZoom, true);
    this.baseZoom = baseZoom;
    window.removeEventListener("resize", this.onResize);
    window.addEventListener("resize", this.onResize);
    viewport.sortableChildren = true;
    this.pixiApp.stage.addChild(viewport);
    this.pixiViewport = viewport;
    this.onResize();
    document.body.appendChild(this.pixiApp.view);
    window.__PIXI_INSPECTOR_GLOBAL_HOOK__ && window.__PIXI_INSPECTOR_GLOBAL_HOOK__.register({ PIXI });
  }
  registerScene(scene) {
    this.scenes[scene.sceneName.toLocaleLowerCase()] = () => {
      const nextScene = new scene(this.pixiApp, this.pixiViewport);
      nextScene.changeScene = this.changeScene.bind(this);
      return nextScene;
    };
  }
  initialize(scene) {
    this.changeScene(scene);
  }
  async changeScene(scene, ...args) {
    if (typeof scene === "string") {
      scene = scene.toLocaleLowerCase();
    } else {
      scene = scene.sceneName.toLocaleLowerCase();
    }
    if (this.currentScene) {
      this.currentScene.destroy();
      this.pixiApp.destroy(false, {
        children: true,
        texture: false,
        baseTexture: false
      });
      this.setupPixi();
    }
    this.currentScene = this.scenes[scene]();
    this.pixiApp.stage.addChild(this.currentScene);
    await this.currentScene.initialize(args ?? []);
    if (this.ticker) {
      this.ticker.stop();
    }
    this.ticker = new Ticker(this.currentScene.timestep, 1e3 / this.currentScene.dt);
    this.ticker.add(this.run.bind(this));
    this.ticker.start();
  }
  run(dt) {
    if (this.currentScene && this.currentScene.run) {
      this.currentScene.run(this.currentScene.timestep === "fixed" ? this.currentScene.dt : dt);
    }
    this.pixiApp.renderer.render(this.pixiApp.stage);
  }
  static GetInstance() {
    return assignGlobalSingleton("gameCoordinator", () => new GameCoordinator());
  }
}
export {
  GameCoordinator
};
//# sourceMappingURL=GameCoordinator.js.map
